<template>
  <div class="client-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Lista de clientes</span>
          </b-col>
<!--          <b-col cols="12" md="6">-->
<!--            <b-row class="d-flex align-items-center justify-content-end" >-->
<!--              <b-col cols="auto">-->
<!--                <b-form-input type="text" :placeholder="'Nome do cliente'" v-model="searchBy"></b-form-input>-->
<!--              </b-col>-->
<!--            </b-row>-->
<!--          </b-col>-->
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <div class="mb-4">
<!--          <b-row class="mb-2">-->
<!--            <b-col>-->
<!--              <label class="cj-label">Período</label>-->
<!--              <date-range-picker-->
<!--                  class="w-100"-->
<!--                  ref="picker"-->
<!--                  :localeData="dateRangePickerPtBrLocale"-->
<!--                  :timePicker="false"-->
<!--                  :timePicker24Hour="false"-->
<!--                  :showDropdowns="true"-->
<!--                  :ranges="false"-->
<!--                  :showWeekNumbers="false"-->
<!--                  :opens="'right'"-->
<!--                  v-model="transactionFilterForm.dateTime">-->
<!--                <div slot="input" slot-scope="picker" class="">-->
<!--                  {{ moment(picker.startDate).format('DD/MM/YYYY') }} - {{ moment(picker.endDate).format('DD/MM/YYYY') }}-->
<!--                </div>-->
<!--              </date-range-picker>-->
<!--            </b-col>-->
<!--          </b-row>-->
          <b-row>
            <b-col>
              <label class="cj-label">Buscar</label>
              <b-form-input type="text" v-model="searchBy" @keyup.enter="getClients(1)"></b-form-input>
            </b-col>
<!--            <b-col>-->
<!--              <label class="cj-label">Categoria</label>-->
<!--              <multiselect v-model="transactionFilterForm.category" :options="categories" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione">-->
<!--                <template slot="clear">-->
<!--                  <div class="multiselect__clear" v-if="transactionFilterForm.category != null" @mousedown.prevent.stop="transactionFilterForm.category = null" @click="alert('ata')"></div>-->
<!--                </template>-->
<!--              </multiselect>-->
<!--            </b-col>-->
            <b-col>
              <label class="cj-label">Status</label>
<!--              <multiselect ref="multiselectPeople" :preserveSearch="true" v-model="transactionFilterForm.patient" :options="people" track-by="name" label="name" :loading="isLoadingPeople" :internal-search="false" :options-limit="20" :limit="5" :limit-text="limitPeople" :max-height="200" @search-change="findPeople" :showLabels="false" placeholder="Selecione">-->
              <multiselect v-model="status" :options="statusOptions" track-by="name" label="name" :showLabels="false" :searchable="false" placeholder="Selecione"></multiselect>
            </b-col>
            <b-col>
              <label class="cj-label">Situação</label>
<!--              <multiselect ref="multiselectPeople" :preserveSearch="true" v-model="transactionFilterForm.patient" :options="people" track-by="name" label="name" :loading="isLoadingPeople" :internal-search="false" :options-limit="20" :limit="5" :limit-text="limitPeople" :max-height="200" @search-change="findPeople" :showLabels="false" placeholder="Selecione">-->
              <multiselect v-model="situation" :options="situationOptions" track-by="name" label="name" :showLabels="false" :searchable="false" placeholder="Selecione"></multiselect>
            </b-col>
            <b-col>
              <label class="cj-label w-100">&nbsp;</label>
              <b-button variant="primary" block @click="getClients(1)"><i class="far fa-search"></i> Filtrar</b-button>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between">
                  <p class="title">Lista de clientes</p>
                  <p class="title"><small>{{ pagination.total }} clientes cadastrados</small></p>
                </div>
              </div>
              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>E-mail</th>
                      <th>Telefone</th>
                      <th>Status</th>
                      <th>Nº de agendas</th>
                      <th>Vencimento</th>
                      <th>Data de cadastro</th>
                      <th>Último agendamento</th>
                    </tr>
                  </thead>
                  <tbody>
                    <router-link tag="tr" :to="'/'+url+'/'+client.id" v-for="client in clients" :key="client.id">
                      <td><i class="fa fa-circle mr-2" :title="getSituation(client).name" :class="'situation-indicator ' + getSituation(client).class"></i>{{ client.name }}</td>
                      <td>{{ client.email }}</td>
                      <td>{{ (client.cellphone != '')?client.cellphone:client.telephone }}</td>
                      <td>{{ statusOptions.find(g => g.value == client.status).name }}</td>
                      <td>{{ client.agendas_count }}</td>
                      <td>{{ client.subscription != null && client.subscription.status == 'ACTIVE' ? moment(client.subscription.valid_until).format('DD/MM/YYYY') : moment(client.created_at).add(7, 'days').format('DD/MM/YYYY') }}</td>
                      <td>{{ moment(client.created_at).format('DD/MM/YYYY') }}</td>
                      <td>{{ client.last_appointment_created_at != null ? moment(client.last_appointment_created_at).format('DD/MM/YYYY') : '' }}</td>
                    </router-link>
                  </tbody>
                </table>
                <p v-if="searchBy == '' && status == '' && clients.length == 0" class="text-center sub-title">Você ainda não possui nenhum cliente cadastrado.</p>
                <p v-if="(searchBy != '' || status != '') && clients.length == 0" class="text-center sub-title">A sua busca por clientes não encontrou nenhum resultado.</p>

                <div v-if="pagination.lastPage > 1">
                  <hr>
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getClients"></b-pagination>
                </div>

              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        url: '',
        newTerm: '',
        module: '',

        pagination: {
          currentPage: 1,
          lastPage: 1,
          perPage: 20,
          total: 0
        },

        canSee: true,
        canEdit: true,

        clients: [],
        clientsFiltered: [],

        statusOptions: [
          { value: 'ACTIVE', name: 'Ativo' },
          { value: 'INACTIVE', name: 'Inativo' },
          { value: 'SUSPENDED', name: 'Suspenso' }
        ],

        situationOptions: [
          { value: 'USING', name: 'Usando', class: 'using' },
          { value: 'STOPPED_USING', name: 'Deixou de usar', class: 'stopped-using' },
          { value: 'NOT_USING_ANYMORE', name: 'Não usa mais', class: 'not-using-anymore' },
          { value: 'NEVER_USED', name: 'Não usou', class: 'never-used' }
        ],

        searchBy: '',
        status: '',
        situation: ''
      }
    },
    mounted () {
      this.eventBus.$emit('IS_LOADING', true);

      this.url = 'clientes';
      this.newTerm = 'cadastrar-cliente';
      this.module = 'clients';

      this.canSee = true;
      this.canEdit = true;

      this.getClients(this.pagination.currentPage);
    },
    methods: {
      getClients(page) {
        let clientsData = {
          name: this.searchBy,
          status: (this.status != null)?this.status.value:null,
          situation: (this.situation != null)?this.situation.value:null,
          page: page
        };
        this.api.getClients(clientsData).then(res => {
          this.clients = res.data.data;

          this.pagination.currentPage = res.data.current_page;
          this.pagination.lastPage = res.data.last_page;
          this.pagination.total = res.data.total;

          this.eventBus.$emit('IS_LOADING', false);

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Clients', res);
        }).catch(err => {
          this.$swal('Ops...', 'Não conseguimos carregar os clientes! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Clients', err.response);
        });
      },

      getSituation(client) {
        let situation = '';
        if(client.last_appointment_created_at == null)
          situation = 'NEVER_USED';
        else if(client.days_without_use <= 4)
          situation = 'USING';
        else if(client.days_without_use <= 15)
          situation = 'STOPPED_USING';
        else
          situation = 'NOT_USING_ANYMORE';

        return this.situationOptions.find(g => g.value == situation);
      },
    }
  }
</script>

<style lang="scss">
  .main-content-cj {
    &.client-list {
      padding: 20px 0;

      .box-cj {
        .content {
          th {
            font-size: 14px;
            color: $cadetGray;
            border-top: 0;
          }

          tbody {
            font-size: 14px;
            color: $waikawaGray;

            .line-add {
              padding: 10px 0;
            }

            tr:nth-child(even) {
              background-color: $whisper;
            }

            tr:nth-child(odd) {
            }

            .situation-indicator {
              font-size: 12px;

              &.using {
                color: $ufoGreen;
              }
              &.stopped-using {
                color: $yellowSea;
              }
              &.not-using-anymore {
                color: $dullRed;
              }
              &.never-used {
                color: #333333;
              }
            }
          }
        }
      }
    }
  }
</style>
